(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/unsubscribe.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/unsubscribe.js');
"use strict";

var _svs;
const {
  WidgetArea
} = svs.components.lbUtils.widgetArea;
const unsubscribeSuccess = ((_svs = svs) === null || _svs === void 0 || (_svs = _svs.my_profile_react) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 ? void 0 : _svs.unsubscribeSuccess) || false;
const Icon = svs.ui.ReactIcon;
const UnsubscribePage = () => {
  if (!unsubscribeSuccess) {
    svs.myProfile.react.shared.dialogs.showCustomersOldLinkError();
  }
  return React.createElement("div", {
    className: "react-container u-flex u-flex-column"
  }, React.createElement("div", {
    className: "unsubscribe-text-container margin-v-4 u-flex u-flex-column u-flex-justify-content-center u-flex-align-items-center"
  }, React.createElement(Icon, {
    icon: "one-to-two",
    size: "1000"
  }), React.createElement("div", {
    className: "f-content margin-h-2"
  }, React.createElement("h1", {
    className: "padding-top-4"
  }, "Vi har tagit emot ditt \xF6nskem\xE5l om att inte f\xE5 fler mejl av den h\xE4r typen fr\xE5n oss."), React.createElement("p", {
    className: "margin-bottom-2"
  }, "Du vet v\xE4l att du n\xE4r som helst kan logga in, g\xE5 till h\xF6germenyn och v\xE4lja vilken information du vill f\xE5 kopplat till ditt spelande?")), React.createElement("div", {
    className: "col-xs-3"
  }, React.createElement("a", {
    className: "u-text-reset",
    href: svs.core.urlMapping.get('loginHome')
  }, React.createElement("button", {
    className: "btn-300 btn-inverted btn-block padding-1 f-body",
    type: "submit"
  }, "Logga in")))), React.createElement("div", {
    className: "sp-widget-area margin-top-4 u-flex col-xs-12 u-flex u-flex-justify-content-center u-flex-align-items-center"
  }, React.createElement("div", {
    className: "unsubscribe-widget"
  }, React.createElement(WidgetArea, {
    widgetArea: "unsubscribe"
  }))));
};
svs.myProfile.UnsubscribePage = UnsubscribePage;

 })(window);